<PageContainer>
	<p>Objednávka je nezávazná. Po jejím odeslání Vás budeme kontaktovat s dalšími informacemi.</p>

	<div class="md:w-1/2">
		<Form>
			<Input
				autocomplete="name"
				label="Celé jméno"
				name="full-name"
				placeholder="Celé jméno"
				type="text" />

			<Input
				autocomplete="tel"
				label="Telefon"
				name="phone"
				placeholder="Telefon"
				type="tel"
				required />

			<Input autocomplete="email" label="E-mail" name="email" placeholder="E-mail" type="email" />

			<AddressWhisper />

			<Textarea
				label="Další poznámka či zpráva"
				name="note"
				placeholder="Rád bych měl rychlejší internet než soused..." />

			<div>
				<Button type="submit">Odeslat</Button>
				<ReCaptcha />
			</div>
		</Form>
	</div>
</PageContainer>

<script lang="ts">
	import PageContainer from '#lib/components/layout/PageContainer.svelte';
	import Form from '#lib/components/ui/Form.svelte';
	import Input from '#lib/components/ui/Input.svelte';
	import AddressWhisper from '#lib/components/layout/AddressWhisper.svelte';
	import Textarea from '#lib/components/ui/Textarea.svelte';
	import ReCaptcha from '#lib/components/globals/ReCaptcha.svelte';
	import Button from '#lib/components/ui/Button.svelte';
</script>
